<template>
  <div class="podcasts">
    <p class="podcasts__ttl">Другие подкасты</p>
    <template v-if="!podcastsOtherListLoading && hasListPodcasts">
      <ul class="podcasts__list">
        <template v-for="podcast in sortedOtherPodcasts">
          <li class="podcasts__item" v-if="podcast.object_id != currentPageId">
            <a 
              class="podcasts__link"
              :href="`/news/${podcast['object_id']}`"
              @click="openPopup($event, podcast['object_id'])"
            >
              {{ podcast.title }}
            </a>
            <div class="podcasts__group">
              <time class="podcasts__date">
                {{ formatTime_dn_mn_y(podcast.date) }}<span class="podcasts__point">·</span>
              </time>
              <CounterComment
                class="podcasts__cloud"
                :count="podcast.comments_count"
                :newCommentsCounter="podcast.comments_count"
                :isClickable="true"
              />
              <time class="podcasts__duration">
                <span class="podcasts__point">·</span>{{ formatSeconds_h_min_s(parseInt(podcast.audio_length)) }}
              </time>
            </div>
          </li>
        </template>
      </ul>
    </template>
    <template v-else>
      <LoaderCircle :size="32" :color="'var(--blue-600)'" />
    </template>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed, onMounted } from 'vue';
  import { useAudioPlayerState } from '@/Groups/Audioplayer/private/composables/computedValues';
  import { formatTime_dn_mn_y, formatSeconds_h_min_s } from '@/Groups/Audioplayer/private/imports/externalUtils';
  import { useContentPopup } from '@/Groups/Audioplayer/private/imports/callContentPopup';
  //-----------------------
  import { CounterComment, LoaderCircle } from '@/Groups/Audioplayer/private/imports/externalTemplates';
  //-----------------------
  const store = useStore();
  //-----------------------
  const { otherPodcasts, podcastsOtherListLoading } = useAudioPlayerState();
  //-----------------------
  const { openContentPopup } = useContentPopup();
  //-----------------------
  onMounted(() => {
    const currentPageId = window.location.pathname.split('/').pop();
    store.dispatch('Audioplayer/toGetNewPodcastsData', currentPageId);
  })
  //-----------------------
  //Имеет ли список подкастов достаточное кол-во аудио для отображения блока?
  const hasListPodcasts = computed(() => {
    return Object.keys(otherPodcasts.value).length >= 3;
  });
  //Cортировка подкастов
  const sortedOtherPodcasts = computed(() => {
    return [...Object.values(otherPodcasts.value)]
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  });
  //------------------------
  //Открыть попап с контентом
  const openPopup = (e, id) => {
    e.preventDefault();
    openContentPopup(id);
  }
</script>

<style lang="scss">
  @import "./styles.scss";
</style>